export class CountryAccessError extends Error {
  constructor() {
    super("App is not available in your country");
    this.name = "CountryAccessError";
  }
}
